import React from 'react'
import { BrowserView } from 'react-device-detect'
import {
  PixelAlert,
  DcDiv,
  DcFlexBox,
  DcInput,
  colors,
  DcDropDown,
} from 'pixel-base'
import CloseIcon from 'utils/icons/close-icon'
import OrdersBulkEdit from './OrdersBulkEdit'

interface Props {
  totalRows: number
  selectedOrders: any[]
  refresh: () => void
  handleClearRows: () => void
  handleUpdate: (...args: any[]) => void
  selectedStore: any
  tableLoading: boolean
  filters: any
  setFilters: (f: any) => void
  searchValue: string
  setSearchValue: (v: string) => void
  debounceFn: (value: string) => void
  appliedFilters: Array<{ id: string; name: string; value: string | null }>
  appliedFiltersIds: any
  setAppliedFiltersIds: (filters: any) => void
  setStateItem: (key: string, value: any) => void
}

const OrdersSubHeader: React.FC<Props> = ({
  totalRows,
  selectedOrders,
  refresh,
  handleClearRows,
  handleUpdate,
  selectedStore,
  tableLoading,
  filters,
  setFilters,
  searchValue,
  setSearchValue,
  debounceFn,
  appliedFilters,
  appliedFiltersIds,
  setAppliedFiltersIds,
  setStateItem,
}) => {
  return (
    <BrowserView style={{ width: '100%' }}>
      <DcFlexBox
        gap="10px"
        flexDirection="row-reverse"
        margin="0 0 5px 0"
        width="100%"
      >
        <DcFlexBox
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          alignContent="center"
          gap="10px"
          width="85%"
        >
          <DcFlexBox justifyContent="flex-end" gap="5px">
            {totalRows > 0 ? (
              <>
                {selectedOrders.length > 0 && (
                  <OrdersBulkEdit
                    refresh={refresh}
                    handleClearRows={handleClearRows}
                    selectedOrders={selectedOrders}
                    handleUpdate={handleUpdate}
                    selectedStore={selectedStore}
                  />
                )}
              </>
            ) : (
              <>
                {tableLoading ? (
                  ''
                ) : (
                  <PixelAlert
                    style={{
                      fontSize: '12px',
                      padding: '5px 10px',
                      fontWeight: '500',
                      marginBottom: '0px',
                    }}
                    variant="info"
                  >
                    There are no orders to display
                  </PixelAlert>
                )}
              </>
            )}
          </DcFlexBox>
          <DcFlexBox width="100%" gap="5px">
            <DcInput
              inputSize="small"
              showsearchicon={0}
              style={{ backgroundColor: colors.grayLighter }}
              maxLength={20}
              placeholder="Search"
              name="search"
              onChange={(ev) => {
                setSearchValue(ev.target.value)
                debounceFn(ev.target.value)
              }}
              value={searchValue}
            />
            <DcDiv width="250px">
              <DcDropDown
                customLabel="Search By"
                dropdownSize={'sm'}
                options={[
                  {
                    label: 'Apply All',
                    value: 'null',
                  },
                  {
                    label: 'Order ID',
                    value: 'order_id',
                  },
                  {
                    label: 'Source Order ID',
                    value: 'source_order_id',
                  },
                  {
                    label: 'Tracking ID',
                    value: 'tracking_id',
                  },
                  {
                    label: 'Customer City',
                    value: 'city',
                  },
                  {
                    label: 'Customer Name',
                    value: 'customer_name',
                  },
                  {
                    label: 'Email Address',
                    value: 'customer_email',
                  },
                  {
                    label: 'Phone Number',
                    value: 'customer_phone',
                  },
                ]}
                onChange={(e) => {
                  setFilters({
                    ...filters,
                    searchBy: e.target.value,
                  })
                }}
                value={filters.searchBy}
                placeholder="Search By"
                width="250px"
              />
            </DcDiv>
          </DcFlexBox>
        </DcFlexBox>

        <DcFlexBox
          flexDirection="row"
          alignItems="center"
          width="50%"
          flexWrap="wrap"
          gap="2px"
          padding="0 0 2px 0 "
        >
          {selectedOrders.length > 0 && (
            <DcDiv position="relative">
              <DcDiv
                style={{
                  border: '1px solid rgba(227, 227, 227, 1)',
                  borderRadius: '.5rem',
                  padding: '2px 10px 2px 10px',
                  fontSize: '12px',
                }}
              >
                Selected:&nbsp;{selectedOrders.length}
              </DcDiv>
            </DcDiv>
          )}
          {appliedFilters?.map((key, index) => (
            <div key={index}>
              {key.value !== null && key.value !== undefined && (
                <DcDiv position="relative">
                  <DcDiv
                    style={{
                      display: 'flex',
                      border: '1px solid rgba(227, 227, 227, 1)',
                      borderRadius: '.5rem',
                      padding: '2px 10px 2px 10px',
                      fontSize: '12px',
                    }}
                    onClick={() => {
                      if (key.name === 'Start Date to End Date') {
                        setFilters({
                          ...filters,
                          start_date: null,
                          end_date: null,
                        })
                      } else {
                        setFilters({ ...filters, [key.id]: null })
                      }
                    }}
                  >
                    <DcDiv>
                      {key.value === '1'
                        ? 'New'
                        : key.value === '2'
                        ? 'Processing'
                        : key.value === '3'
                        ? 'Tracking'
                        : key.value === '6'
                        ? 'Returns'
                        : key.value === '4'
                        ? 'Completed'
                        : key.value === '7'
                        ? 'Post Delivery'
                        : key.value === '5'
                        ? 'Cancelled'
                        : key.value}
                    </DcDiv>
                    &nbsp;
                    <DcDiv
                      style={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <CloseIcon size={12} />
                    </DcDiv>
                  </DcDiv>
                </DcDiv>
              )}
            </div>
          ))}
          {Object.keys(appliedFiltersIds).length > 0 &&
            appliedFilters.some(
              (filter) => filter.value !== null && filter.value !== undefined,
            ) && (
              <DcDiv
                style={{
                  border: '1px solid rgba(227, 227, 227, 1)',
                  borderRadius: '.5rem',
                  padding: '2px 10px 2px 10px',
                  fontSize: '12px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setStateItem('selectedStatus', null)
                  setFilters({
                    store_id: null,
                    courier_id: null,
                    tag: null,
                    start_date: null,
                    end_date: null,
                    page: 0,
                    id: null,
                    status_classification_id: null,
                    page_size: 50,
                    q: null,
                  })
                  setAppliedFiltersIds({
                    store_id: null,
                    courier_id: null,
                    tag: null,
                    start_date: null,
                    end_date: null,
                    page: null,
                    id: null,
                    status_classification_id: null,
                    page_size: null,
                    q: null,
                  })
                }}
              >
                Reset All
              </DcDiv>
            )}
        </DcFlexBox>
      </DcFlexBox>
    </BrowserView>
  )
}

export default OrdersSubHeader
